"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getListFromTableResponses = exports.getTableCellResponse = exports.filterOutFreetextResponses = exports.findResponse = exports.getSpecificTaskResponses = exports.getUpdatedResponsesForTask = exports.buildResponseLookup = exports.buildResponseFormVm = exports.parseResponseSaveResult = exports.parseInsertedResponse = exports.getResponseHash = exports.calculateSubtotals = exports.calculateResponseScore = void 0;
var objectUtils_1 = require("./objectUtils");
var calculateResponseScore = function (response) {
    var _a;
    if (!response) {
        return 0;
    }
    if ((0, objectUtils_1.hasValue)(response.scaleResponse)) {
        return response.scaleResponse || 0;
    }
    if (((_a = response.choiceResponse) === null || _a === void 0 ? void 0 : _a.length) && response.choiceResponse.length > 0) {
        return response.choiceResponse.reduce(function (prev, curr) { return prev + ((curr === null || curr === void 0 ? void 0 : curr.score) || 0); }, 0);
    }
    return 0;
};
exports.calculateResponseScore = calculateResponseScore;
var getQuestionResponses = function (taskResponses, onlyWithChange) { return (taskResponses ? (Object.entries(taskResponses)
    .filter(function (_a) {
    var currQuestionId = _a[0], respValue = _a[1];
    return currQuestionId && respValue && respValue.response && !respValue.isSubtotal && (respValue.changeKey || !onlyWithChange);
})
    .map(function (_a) {
    var currQuestionId = _a[0], respValue = _a[1];
    return ({ questionId: Number(currQuestionId), response: respValue.response });
})) : []); };
var calculateSubtotals = function (taskResponses, taskSubtotals) {
    var scoresByQuestionId = getQuestionResponses(taskResponses, false)
        .reduce(function (prev, curr) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[curr.questionId || '_err'] = (0, exports.calculateResponseScore)(curr.response), _a)));
    }, {});
    var ret = taskSubtotals.map(function (_a) {
        var taskSubtotalId = _a.id, questionIds = _a.questionIds;
        var subTotalSum = (questionIds === null || questionIds === void 0 ? void 0 : questionIds.length) > 0
            ? questionIds.reduce(function (sum, questionId) { return sum + (scoresByQuestionId[questionId] || 0); }, 0)
            : Object.values(scoresByQuestionId).reduce(function (sum, score) { return (sum + score); }, 0);
        return {
            taskSubtotalId: taskSubtotalId,
            response: { scaleResponse: subTotalSum },
        };
    });
    return ret;
};
exports.calculateSubtotals = calculateSubtotals;
var getResponseHash = function (response) { return (response ? JSON.stringify({
    f: response.freetextResponse,
    c: response.choiceResponse,
    s: response.scaleResponse,
    t: response.tableResponses,
}) : null); };
exports.getResponseHash = getResponseHash;
var reduceResponsesForTask = function (newResponses, currentResponseList, taskId, taskVersion, patientProgramElementId, formId, formSubmitted) {
    var _a, _b;
    var _c;
    if (formSubmitted === void 0) { formSubmitted = null; }
    if (!(newResponses === null || newResponses === void 0 ? void 0 : newResponses.length) && !formSubmitted) {
        return currentResponseList || {};
    }
    var existingResponsesForElement = (currentResponseList && currentResponseList[patientProgramElementId]) || {};
    var newModuleResponses = newResponses === null || newResponses === void 0 ? void 0 : newResponses.filter(function (d) { return d.moduleSubtotalId; });
    var filteredNewResponses = newResponses === null || newResponses === void 0 ? void 0 : newResponses.filter(function (d) { return !d.moduleSubtotalId; });
    if (newModuleResponses) {
        newModuleResponses.forEach(function (newModuleRespons) {
            var _a;
            var p = Object.values(existingResponsesForElement).find(function (d) { return newModuleRespons.moduleSubtotalId && d[newModuleRespons.moduleSubtotalId]; });
            if (p && newModuleRespons.moduleSubtotalId) {
                // Update existing respons instead of adding new (could have different taskId!)
                existingResponsesForElement[p.taskId] = __assign(__assign({}, existingResponsesForElement[p.taskId]), (_a = {}, _a[newModuleRespons.moduleSubtotalId] = __assign(__assign({}, p[newModuleRespons.moduleSubtotalId]), { response: newModuleRespons.response }), _a));
            }
            else {
                filteredNewResponses.push(newModuleRespons);
            }
        });
    }
    var existingResponsesForTask = __assign(__assign({}, existingResponsesForElement[taskId]), { patientProgramElementId: patientProgramElementId, taskId: taskId, formId: formId, taskVersion: taskVersion, submitted: formSubmitted || ((_c = existingResponsesForElement[taskId]) === null || _c === void 0 ? void 0 : _c.submitted) });
    return __assign(__assign({}, currentResponseList), (_a = {}, _a[patientProgramElementId] = __assign(__assign({}, existingResponsesForElement), (_b = {}, _b[taskId] = __assign(__assign({}, existingResponsesForTask), filteredNewResponses === null || filteredNewResponses === void 0 ? void 0 : filteredNewResponses.reduce(function (prev, curr) {
        var _a;
        return (__assign(__assign({}, prev), (_a = {}, _a[curr.questionId || curr.taskSubtotalId || curr.moduleSubtotalId || '_err'] = {
            response: curr.response,
            isSubtotal: !!(curr.taskSubtotalId || curr.moduleSubtotalId),
            changeKey: curr.changeKey,
        }, _a)));
    }, {})), _b)), _a));
};
var parseInsertedResponse = function (inputData, subtotals, currentResponses) {
    var patientProgramElementId = inputData.patientProgramElementId, taskId = inputData.taskId, taskVersion = inputData.taskVersion, responses = inputData.responses, formId = inputData.formId;
    var newResponses = responses.map(function (_a) {
        var questionId = _a.questionId, response = __rest(_a, ["questionId"]);
        return ({
            changeKey: (0, exports.getResponseHash)(response),
            questionId: questionId,
            response: response,
        });
    });
    var responseList = reduceResponsesForTask(newResponses, currentResponses, taskId, taskVersion, patientProgramElementId, formId);
    if (subtotals.length && responseList[patientProgramElementId] && responseList[patientProgramElementId][taskId]) {
        var newTaskSubtotalResponses = (0, exports.calculateSubtotals)(responseList[patientProgramElementId][taskId], subtotals);
        responseList = reduceResponsesForTask(newTaskSubtotalResponses, responseList, taskId, taskVersion, patientProgramElementId, formId);
    }
    return responseList;
};
exports.parseInsertedResponse = parseInsertedResponse;
var parseResponseSaveResult = function (inputData, taskVisitResult, currentResponses) {
    var _a = inputData || {}, responses = _a.responses, taskVersion = _a.taskVersion;
    var newResponses = taskVisitResult.newResponses, patientProgramElementId = taskVisitResult.patientProgramElementId, taskId = taskVisitResult.taskId, formId = taskVisitResult.formId, formSubmitted = taskVisitResult.formSubmitted;
    var savedResponses = responses === null || responses === void 0 ? void 0 : responses.map(function (_a) {
        var questionId = _a.questionId, response = __rest(_a, ["questionId"]);
        return ({
            changeKey: null,
            questionId: questionId,
            response: response,
        });
    }).filter(function (d) {
        var _a;
        if (!currentResponses || !currentResponses[patientProgramElementId] || !currentResponses[patientProgramElementId][taskId]
            || (d.questionId && !((_a = currentResponses[patientProgramElementId][taskId][d.questionId]) === null || _a === void 0 ? void 0 : _a.response))) {
            return true;
        }
        if (d.questionId && currentResponses[patientProgramElementId][taskId][d.questionId].changeKey === (0, exports.getResponseHash)(d.response)) {
            return true;
        }
        return false;
    }).concat(newResponses || []);
    return reduceResponsesForTask(savedResponses, currentResponses, taskId, taskVersion, patientProgramElementId, formId, formSubmitted);
};
exports.parseResponseSaveResult = parseResponseSaveResult;
var buildResponseFormVm = function (form) {
    var _a;
    var formProps = __assign({}, form);
    delete formProps.responses; // remove responses-list from props -> this is spread out on [questionId]
    var formVm = __assign(__assign({}, formProps), (_a = form.responses) === null || _a === void 0 ? void 0 : _a.reduce(function (rPrev, rCurr) {
        var _a;
        return (__assign(__assign({}, rPrev), (_a = {}, _a[rCurr.questionId || rCurr.taskSubtotalId || rCurr.moduleSubtotalId || '_err'] = {
            // could remove "response" prop and decompose all subProps directly. But must remove .response references a lot of places..
            response: rCurr.response,
            isSubtotal: !!(rCurr.taskSubtotalId || rCurr.moduleSubtotalId),
        }, _a)));
    }, {}));
    return formVm;
};
exports.buildResponseFormVm = buildResponseFormVm;
var buildResponseLookup = function (responseList, existingResponseList) { return (responseList === null || responseList === void 0 ? void 0 : responseList.reduce(function (prev, form) {
    var _a, _b;
    var formVm = (0, exports.buildResponseFormVm)(form);
    return __assign(__assign({}, prev), (_a = {}, _a[form.patientProgramElementId] = __assign(__assign({}, prev[form.patientProgramElementId]), (_b = {}, _b[form.taskId] = formVm, _b)), _a));
}, existingResponseList || {})) || existingResponseList || {}; };
exports.buildResponseLookup = buildResponseLookup;
var getUpdatedResponsesForTask = function (taskResponses, patientProgramElementId, taskId, taskVersion, formId, submitForm) {
    if (!taskResponses && !submitForm) {
        return null;
    }
    var updatedResponsesForTask = getQuestionResponses(taskResponses, true)
        .reduce(function (prev, curr) { return (__spreadArray(__spreadArray([], prev, true), [__assign({ questionId: Number(curr.questionId) }, __assign({}, curr.response))], false)); }, []);
    if (updatedResponsesForTask.length || submitForm) {
        var responseData = {
            patientProgramElementId: patientProgramElementId,
            taskId: taskId,
            taskVersion: taskVersion,
            formId: formId,
            responses: updatedResponsesForTask,
            submit: submitForm,
        };
        return responseData;
    }
    return null;
};
exports.getUpdatedResponsesForTask = getUpdatedResponsesForTask;
var getSpecificTaskResponses = function (existingResponseList, currentTaskResponse) { return function (taskId, subtotalId) {
    if ((currentTaskResponse === null || currentTaskResponse === void 0 ? void 0 : currentTaskResponse.taskId) === taskId) {
        return currentTaskResponse;
    }
    if (!existingResponseList) {
        return null;
    }
    if (subtotalId) {
        return Object.values(existingResponseList).reduce(function (prevPpe, currPpe) { return prevPpe
            || Object.values(currPpe).reduce(function (prevTask, taskResponse) { return prevTask
                || ((taskResponse === null || taskResponse === void 0 ? void 0 : taskResponse[subtotalId]) ? taskResponse : null); }, null); }, null);
    }
    return Object.values(existingResponseList).reduce(function (prevPpe, currPpe) { return prevPpe
        || Object.values(currPpe).reduce(function (prevTask, taskResponse) { return prevTask
            || ((taskResponse === null || taskResponse === void 0 ? void 0 : taskResponse.taskId) === taskId ? taskResponse : null); }, null); }, null);
}; };
exports.getSpecificTaskResponses = getSpecificTaskResponses;
var findResponse = function (taskResponses, taskId, questionId) {
    if (taskResponses && taskId && questionId) {
        var currentTaskResponses = (0, exports.getSpecificTaskResponses)(taskResponses)(taskId);
        return currentTaskResponses && currentTaskResponses[questionId] ? currentTaskResponses[questionId].response : null;
    }
    return null;
};
exports.findResponse = findResponse;
var filterOutFreetextResponses = function (patientProgramTaskResponse) {
    var _a;
    return patientProgramTaskResponse && __assign(__assign({}, patientProgramTaskResponse), { responses: (_a = patientProgramTaskResponse.responses) === null || _a === void 0 ? void 0 : _a.map(function (r) { return ({
            questionId: r.questionId,
            scaleResponse: r.scaleResponse,
        }); }).filter(function (r) { return (0, objectUtils_1.hasValue)(r.scaleResponse); }) });
};
exports.filterOutFreetextResponses = filterOutFreetextResponses;
var getTableCellResponse = function (tableResponse, rowIndex, cellIndex, questionKeyOrIndex) {
    var _a;
    var cellJson = (_a = tableResponse === null || tableResponse === void 0 ? void 0 : tableResponse[rowIndex]) === null || _a === void 0 ? void 0 : _a[cellIndex];
    var cellObject = cellJson ? JSON.parse(cellJson) : null;
    return cellObject === null || cellObject === void 0 ? void 0 : cellObject[questionKeyOrIndex];
};
exports.getTableCellResponse = getTableCellResponse;
var getListFromTableResponses = function (tableResponses, singleQuestionInCell) { return tableResponses === null || tableResponses === void 0 ? void 0 : tableResponses.flatMap(function (r) { return r.map(function (c) {
    var respObj = c ? JSON.parse(c) : null;
    if (respObj && singleQuestionInCell) {
        return respObj[0]; // respObj is not an array but a single question has propertyName = 0
    }
    return respObj;
}); }); };
exports.getListFromTableResponses = getListFromTableResponses;
